






































































































import { Component, PropSync, Vue } from 'vue-property-decorator';
import { decimal, minLength, required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import Toast from '../display/toast.vue';
import { WaterMonitorsApi } from '@/api';
import { WATER_ENTITY_BILLING_TIERS } from '@/models/ordway';

@Component({
	components: {},
	validations: {
		addNewWaterMonitorModal: {
			name: {
				required,
				minLength: minLength(1),
				unique(value) {
					return this.addNewWaterMonitorModalNameUnique;
				},
			},
			litresPerPulse: { decimal },
			location: {
				lat: { decimal },
				lng: { decimal },
			},
			billingTier: { required },
		},
	},
	mixins: [validationMixin],
})
export default class WaterMonitorForm extends Vue {
	private waterMonitorsApi: WaterMonitorsApi = new WaterMonitorsApi();
	public addNewWaterMonitorModalNameUnique = true;
	@PropSync('product') public localProduct!: object;
	@PropSync('monitors') public localMonitors!: any[];

	public addNewWaterMonitorModal = {
		name: null,
		litresPerPulse: null,
		location: {
			lat: null,
			lng: null,
		},
		billingTier: null,
	};

	public async addNewWaterMonitor(e: any) {
		if (
			this.addNewWaterMonitorModal.name &&
			!this.isNameUnique(this.addNewWaterMonitorModal.name)
		) {
			this.addNewWaterMonitorModalNameUnique = false;
			e.preventDefault();
			return;
		}
		this.addNewWaterMonitorModalNameUnique = true;
		if (!this.addNewItem(e, 'addNewWaterMonitorModal', 'add-water-monitor-modal')) {
			return;
		}

		await this.makeRequest('Water Usage', 'Adding', 'Added', async () => {
			await this.waterMonitorsApi.addWaterMonitor({
				data: {
					productId: +this.$route.params.productId,
					status: 'install',
					name:
						this.addNewWaterMonitorModal.name ||
						`Water Usage ${this.product.watermonitors.length + 1}`,
					litresPerPulse: +(this.addNewWaterMonitorModal.litresPerPulse || 0),
					locationLat: +(this.addNewWaterMonitorModal.location.lat || 0),
					locationLng: +(this.addNewWaterMonitorModal.location.lng || 0),
					billingTier: this.addNewWaterMonitorModal.billingTier,
				},
			});
		});
		this.$emit('closeModal');
	}

	public get billingTierOptions() {
		return WATER_ENTITY_BILLING_TIERS;
	}

	public isValid(field: any) {
		return field && field.$dirty ? !field.$invalid : null;
	}

	public isNameUnique(name: string | null) {
		return (
			name == null ||
			[
				...this.localProduct.watermeters,
				...this.localProduct.watertanks,
				...this.localProduct.watermonitors,
			].findIndex(entity => entity.name.toLowerCase() === name.toLowerCase()) === -1
		);
	}

	private addNewItem(event: any, modalValidate: string, modal: string): boolean {
		if (this.$v[modalValidate] != null) {
			this.$v[modalValidate].$touch();
			if (this.$v[modalValidate].$invalid) {
				this.submitStatus = 'ERROR';
				event.preventDefault();
				return false;
			}
		}
		this.$emit('closeModal');
		this.$emit('loadProduct');

		this.submitStatus = 'PENDING';
		return true;
	}

	public setLocation(type: string) {
		navigator.geolocation.getCurrentPosition(
			position => {
				this[`addNewWater${type}Modal`].location.lat = +position.coords.latitude || 0;
				this[`addNewWater${type}Modal`].location.lng = +position.coords.longitude || 0;
				const locationValidator = this.$v[`addNewWater${type}Modal`].location;
				if (locationValidator) {
					locationValidator.$touch();
				}
			},
			err => {
				console.log('Failed to get your current location:', err);
				new Toast().makeToast(
					'Failed to get your current location: {reason: err.message || err n}',
					'Geo - Location',
					'Error',
					'danger',
				);
			},
		);
	}

	private async makeRequest(
		type: string,
		actioning: string,
		actioned: string,
		runnable: () => void,
		reload: boolean = true,
	) {
		try {
			await runnable();
		} catch (ex) {
			let error;

			if (ex.response && ex.response.data) {
				error = ex.response.data.message;
			} else if (ex.request) {
				error = 'Network Error';
			} else {
				error = 'Unknown Error';
			}

			new Toast().makeToast(
				`${type} not ${actioned}: ${error}`,
				`Error ${actioning} ${type}`,
				'danger',
				true,
			);
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast(`${type} ${actioned}`, 'Success', 'success');
		if (reload) {
			setTimeout(() => this.$emit('loadProduct'), 1000);
		}
	}
}
